import { NumberDecimalFormat } from '@components/shared/Format'
import { Constants } from '@models/Constants'
import { Store } from '@stores/Store'

export class PerformanceIncentiveCalculation {
  store!: Store

  constructor(store: Store) {
    this.store = store
  }

  // Performance Incentive

  get performanceMonthlyAmount(): number {
    const { store } = this
    const { rubyBV } = store

    if (this.performanceAllCriteriaMet) {
      return NumberDecimalFormat(rubyBV * Constants.PERFORMANCE_BONUS_PERCENT)
    }

    return 0
  }

  get performanceAnnualAmount(): number {
    return this.performanceMonthlyAmount * 12
  }

  get performanceAllCriteriaMet(): boolean {
    const { store } = this
    const { performanceIncentiveStore } = store

    const { performanceIncentiveActive } = performanceIncentiveStore
    if (!performanceIncentiveActive) { return false }
    return this.performanceRubyPVCriteriaMet && this.performancePPVCriteriaMet
  }

  get performanceMinRubyPV(): number {
    const { store } = this
    const { countryHelper } = store
    const { selectedANZ } = countryHelper

    return selectedANZ ? Constants.PERFORMANCE_MIN_RUBY_PV_ANZ_2024 : Constants.PERFORMANCE_MIN_RUBY_PV_EU_2024
  }

  get performanceRubyPVCriteriaMet(): boolean {
    const { store } = this
    const { rubyPV } = store

    return rubyPV >= this.performanceMinRubyPV
  }

  get performancePPVCriteriaMet(): boolean {
    const { store } = this
    const { personalPV, countryHelper } = store
    const { selectedANZ } = countryHelper

    if (selectedANZ) {
      return personalPV >= Constants.MONTHLY_PPV_ANZ
    }

    return personalPV >= Constants.MONTHLY_PPV_EUROPE
  }

  get personalPVCriteria() {
    const { store } = this
    const { countryHelper } = store
    const { selectedANZ } = countryHelper

    if (selectedANZ) { return Constants.MONTHLY_PPV_ANZ }

    return Constants.MONTHLY_PPV_EUROPE
  }

  get personalPVValue() {
    return this.personalPVCriteria
  }

}
